// extracted by css-extract-rspack-plugin
export default {"button":"Viewer__button--V50Jq","buttonEdit":"Viewer__buttonEdit--W3vGX Viewer__button--V50Jq","buttonIcon":"Viewer__buttonIcon--fqJ_i"};